import { useEffect, useRef } from "react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";

export const Field = ({ label, required, children, className = "" }) => (
  <div className={`space-y-1.5 ${className}`}>
    <Label className="text-sm font-medium">{label}{required && <span className="text-destructive"> *</span>}</Label>
    {children}
  </div>
);

export const SelectField = ({ value, onChange, options, placeholder, testid }) => (
  <Select value={value || undefined} onValueChange={onChange}>
    <SelectTrigger className="h-11 rounded-xl" data-testid={testid}><SelectValue placeholder={placeholder} /></SelectTrigger>
    <SelectContent className="max-h-72">
      {options.map((o) => <SelectItem key={o} value={o} data-testid={`${testid}-option-${o.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{o}</SelectItem>)}
    </SelectContent>
  </Select>
);

export function usePinAutofill(pincode, onFound) {
  const cb = useRef(onFound);
  cb.current = onFound;
  useEffect(() => {
    if (!/^[1-9]\d{5}$/.test(pincode || "")) return;
    let alive = true;
    api.get(`/pincodes/lookup/${pincode}`).then(({ data }) => { if (alive) cb.current(data); }).catch(() => {});
    return () => { alive = false; };
  }, [pincode]);
}

export const inputCls = "h-11 rounded-xl";
